import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Style from './Links.module.scss';

class Links extends Component {
  constructor(props) {
    super(props);
    this.getLinks = this.getLinks.bind(this);
  }

  getLinks(item, index) {
    const { data, theme, disableH1 = false } = this.props;
    const isLastItem = data.length === index + 1;
    const { '@id': url, name } = item;
    const lastLinkStyle = classNames(Style.lastLink, theme.lastLink);
    const linkStyle = classNames(Style.link, theme.link);
    const linkClassNames = isLastItem ? lastLinkStyle : linkStyle;
    if (!url || !name) return null;
    const formattedItem = isLastItem && !disableH1 ? <h1>{name}</h1> : name;
    return (
      <li data-test="links-item" className={linkClassNames} key={`breadcrumb-${index}-${name}`}>
        <Link to={url} title={name} onlyActiveOnIndex>
          {formattedItem}
        </Link>
      </li>
    );
  }

  render() {
    const { data } = this.props;
    if (!data) return null;
    const links = data.map(this.getLinks);
    return <ol data-test="links">{links}</ol>;
  }
}

Links.defaultProps = {
  data: [],
  theme: {},
};

Links.propTypes = {
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool])),
  disableH1: PropTypes.bool,
  theme: PropTypes.shape({}),
};
export default Links;
